import { render, staticRenderFns } from "./OIDCLogin.vue?vue&type=template&id=13e0bb4d&scoped=true"
import script from "./OIDCLogin.vue?vue&type=script&lang=js"
export * from "./OIDCLogin.vue?vue&type=script&lang=js"
import style0 from "./OIDCLogin.vue?vue&type=style&index=0&id=13e0bb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/kolibri-tools/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0bb4d",
  null
  
)

export default component.exports